import { LOCALE_REGEX_PATTERN } from './constants';
/**
 * Parses valid locale.
 * @example
 * // returns { locale: 'en_gb', lang: 'en', country: 'gb', separator: '_' }
 * parseLocale('en_gb')
 * @param {string} locale - Locale that needs to be parsed.
 * @returns {object} - Locale info.
 */
const parseLocale = (locale) => { var _a; return (_a = locale.match(LOCALE_REGEX_PATTERN)) === null || _a === void 0 ? void 0 : _a.groups; };
export default parseLocale;
//# sourceMappingURL=parseLocale.js.map